(() => {
  const bannerSelector = '#shopify-pc__banner';
  const prefsSelector = '#shopify-pc__prefs';
  const prefsDialogSelector = '#shopify-pc__prefs__dialog';
  const prefsScrollableSelector = `${prefsDialogSelector} .shopify-pc__prefs__scrollable`;
  const suppressedBannerClass = 'hy-cookie-banner-suppressed';
  const customCloseClass = 'hy-cookie-prefs-close';
  const hiddenNativeCloseClass = 'hy-cookie-native-close';

  const isJapaneseStorefront = document.documentElement.lang
    .toLowerCase()
    .startsWith('ja');

  const copy = isJapaneseStorefront
    ? {
        accept: 'すべて許可',
        decline: 'すべて拒否',
        preferencesTitle: 'Cookieとプライバシー設定',
        save: '選択内容を保存',
        introTitle: 'お客様のデータ管理',
        introBody:
          '当ウェブサイトで使用するCookieについて確認し、パーソナライズ、マーケティング、分析の各Cookieを許可するか選択できます。設定はフッターの「Cookie設定」からいつでも変更できます。',
        essentialTitle: '必須',
        essentialBody:
          'これらのCookieは、安全なチェックアウト、アカウント機能、不正防止、カート内商品の保持など、サイトを正常に機能させるために必要です。',
        personalizationTitle: 'パーソナライズ',
        personalizationBody:
          'お客様の選択内容を記憶し、次回のご利用時により適切な体験を提供するために使用されます。',
        marketingTitle: 'マーケティング',
        marketingBody:
          '当ウェブサイトおよびShopifyを含む提携先が、マーケティングの効果測定や、法令上認められる範囲で関連性の高い広告を表示するために使用します。',
        analyticsTitle: '分析',
        analyticsBody:
          'サイトの利用状況を把握し、機能、パフォーマンスおよびお客様の体験を改善するために使用します。',
        alwaysEnabled: '常に有効',
        closeLabel: 'Cookie設定を閉じる',
      }
    : {
        bannerTitle: 'Your privacy choices',
        bannerMessage:
          'We use essential cookies to operate the store. With your permission, we also use cookies to remember preferences, understand how the site is used, and support personalised marketing. You can accept, decline, or manage non-essential cookies. Learn more in our ',
        manage: 'Manage preferences',
        accept: 'Accept all',
        decline: 'Decline non-essential',
        preferencesTitle: 'Cookie preferences',
        save: 'Save preferences',
        introTitle: 'Your privacy choices',
        introBody:
          'Essential cookies keep the store secure and functional. Choose whether to allow personalisation, analytics, and marketing cookies. You can update these choices at any time through Cookie Settings in the footer.',
        essentialTitle: 'Essential',
        essentialBody:
          'These cookies are required for core store functions, including secure checkout, account access, fraud prevention, and keeping items in your bag.',
        personalizationTitle: 'Personalisation',
        personalizationBody:
          'These cookies remember choices you make and help us tailor your experience when you return.',
        marketingTitle: 'Marketing',
        marketingBody:
          'These cookies help us and our partners, including Shopify, measure campaigns and show more relevant advertising where permitted.',
        analyticsTitle: 'Analytics',
        analyticsBody:
          'These cookies help us understand how the site is used and where we can improve its performance and experience.',
        closeLabel: 'Close cookie preferences',
      };

  let updateQueued = false;
  let lockedScrollY = window.scrollY;
  let privacyBannerLoader = null;
  let observedPreferences = null;
  let preferencesObserver = null;

  const queryFirst = (selectors) => {
    for (const selector of selectors) {
      const element = document.querySelector(selector);
      if (element) return element;
    }
    return null;
  };

  const setText = (element, text) => {
    if (element && element.textContent.trim() !== text) {
      element.textContent = text;
    }
  };

  const setLabelText = (containerSelector, text) => {
    const label = document.querySelector(`${containerSelector} label`);
    if (!label) return;

    const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();

    while (node) {
      if (node.textContent.trim()) {
        if (node.textContent.trim() !== text) node.textContent = ` ${text}`;
        return;
      }
      node = walker.nextNode();
    }
  };

  const setOptionCopy = (selector, title, body) => {
    setLabelText(selector, title);
    setText(document.querySelector(`${selector} p`), body);
  };

  const replaceExactText = (root, sourceValues, replacement) => {
    if (!root) return false;

    const matches = sourceValues.map((value) =>
      value.replace(/\s+/g, ' ').trim().toLowerCase()
    );
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();

    while (node) {
      const value = node.textContent.replace(/\s+/g, ' ').trim().toLowerCase();

      if (matches.includes(value)) {
        node.textContent = ` ${replacement}`;
        return true;
      }

      node = walker.nextNode();
    }

    return false;
  };

  const localizeJapaneseFallbackCopy = () => {
    if (!isJapaneseStorefront) return;

    const dialog = document.querySelector(prefsDialogSelector);
    if (!dialog) return;

    replaceExactText(
      dialog,
      ['Personalization', 'Personalisation'],
      copy.personalizationTitle
    );
    replaceExactText(
      dialog,
      [
        'These cookies store details about your actions to personalize your next visit to the website.',
        'These cookies remember choices you make and help us tailor your experience when you return.',
      ],
      copy.personalizationBody
    );
    replaceExactText(
      dialog,
      ['Always enabled', 'Always active'],
      copy.alwaysEnabled
    );
  };

  const ensureJapaneseStatusStyle = () => {
    if (!isJapaneseStorefront || document.getElementById('hy-cookie-ja-status-style')) return;

    const style = document.createElement('style');
    style.id = 'hy-cookie-ja-status-style';
    style.textContent = `
      html[lang^="ja"] #shopify-pc__prefs__essential label::after {
        content: "常に有効" !important;
      }
    `;
    document.head.appendChild(style);
  };

  const setAlwaysEnabledCopy = () => {
    if (!isJapaneseStorefront) return;

    ensureJapaneseStatusStyle();

    const essential = document.querySelector('#shopify-pc__prefs__essential');
    if (!essential) return;

    const directMatch = queryFirst([
      '#shopify-pc__prefs__essential [class*="always"]',
      '#shopify-pc__prefs__essential [data-always-enabled]',
    ]);

    if (directMatch) {
      setText(directMatch, copy.alwaysEnabled);
      return;
    }

    const walker = document.createTreeWalker(essential, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();

    while (node) {
      const value = node.textContent.trim().toLowerCase();
      if (value === 'always enabled' || value === 'always active') {
        node.textContent = ` ${copy.alwaysEnabled}`;
        return;
      }
      node = walker.nextNode();
    }
  };

  const styleEssentialCheckbox = () => {
    const label = document.querySelector('#shopify-pc__prefs__essential label');
    const indicator = label?.querySelector(':scope > span[aria-hidden="true"]');
    if (!label || !indicator) return;

    label.style.setProperty('margin-left', '0', 'important');
    label.style.setProperty('gap', '14px', 'important');
    indicator.style.setProperty('display', 'block', 'important');
    indicator.style.setProperty('border-color', 'rgba(17,17,17,.38)', 'important');
    indicator.style.setProperty('background', 'rgba(17,17,17,.38)', 'important');
  };

  const clearSelection = () => {
    const selection = window.getSelection?.();
    if (selection?.rangeCount) selection.removeAllRanges();
  };

  const clearCookiePointerFocus = () => {
    clearSelection();
    const activeElement = document.activeElement;

    if (
      activeElement instanceof HTMLElement &&
      (activeElement.closest(bannerSelector) || activeElement.closest(prefsSelector))
    ) {
      activeElement.blur();
    }
  };

  const clearCookiePointerFocusAfterOpen = () => {
    requestAnimationFrame(clearCookiePointerFocus);
    window.setTimeout(clearCookiePointerFocus, 0);
    window.setTimeout(clearCookiePointerFocus, 80);
  };

  const findNativeClose = (header) => {
    if (!header) return null;

    return Array.from(header.querySelectorAll('button')).find(
      (button) =>
        !button.classList.contains(customCloseClass) &&
        !button.matches(
          '#shopify-pc__prefs__header-accept, #shopify-pc__prefs__header-decline, #shopify-pc__prefs__header-save'
        )
    );
  };

  const ensureCloseControl = () => {
    const header = document.querySelector(`${prefsDialogSelector} > header`);
    if (!header) return;

    const nativeClose = findNativeClose(header);
    nativeClose?.classList.add(hiddenNativeCloseClass);

    let close = header.querySelector(`.${customCloseClass}`);
    if (!close) {
      close = document.createElement('button');
      close.type = 'button';
      close.className = customCloseClass;
      close.innerHTML = '<span aria-hidden="true">×</span>';
      header.appendChild(close);
    }

    close.setAttribute('aria-label', copy.closeLabel);
  };

  const preferencesAreOpen = () => {
    const preferences = document.querySelector(prefsSelector);
    if (!preferences) return false;

    const style = window.getComputedStyle(preferences);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      preferences.getAttribute('aria-hidden') !== 'true'
    );
  };

  const closePreferences = () => {
    const header = document.querySelector(`${prefsDialogSelector} > header`);
    const nativeClose = findNativeClose(header);

    if (nativeClose) {
      nativeClose.click();
      window.setTimeout(scheduleUpdate, 0);
      return;
    }

    document.dispatchEvent(
      new KeyboardEvent('keydown', {
        key: 'Escape',
        code: 'Escape',
        bubbles: true,
      })
    );

    window.setTimeout(() => {
      const preferences = document.querySelector(prefsSelector);
      if (preferencesAreOpen() && preferences) {
        preferences.setAttribute('aria-hidden', 'true');
        preferences.style.setProperty('display', 'none', 'important');
      }
      scheduleUpdate();
    }, 0);
  };

  const syncOpenState = () => {
    const open = preferencesAreOpen();
    const wasOpen = document.body.classList.contains('hy-cookie-prefs-open');

    if (open && !wasOpen) lockedScrollY = window.scrollY;

    document.body.classList.toggle('hy-cookie-prefs-open', open);
    document
      .querySelector(bannerSelector)
      ?.classList.toggle(suppressedBannerClass, open);
  };

  const setBannerMessage = () => {
    const message = queryFirst([
      '#shopify-pc__banner__body-message',
      '#shopify-pc__banner .shopify-pc__banner__body p',
      '#shopify-pc__banner p',
    ]);
    if (!message) return;

    if (
      message.dataset.hyCookieCopy === 'international' &&
      message.textContent.includes('We use essential cookies to operate the store.')
    ) {
      return;
    }

    let link = message.querySelector('a');
    if (!link) {
      link = document.createElement('a');
      link.href = '/policies/privacy-policy';
    }

    setText(link, 'Privacy Policy');
    message.replaceChildren(
      document.createTextNode(copy.bannerMessage),
      link,
      document.createTextNode('.')
    );
    message.dataset.hyCookieCopy = 'international';
  };

  const applyPreferencesCopy = () => {
    setText(document.querySelector('#shopify-pc__prefs__header-title'), copy.preferencesTitle);
    setText(document.querySelector('#shopify-pc__prefs__header-accept'), copy.accept);
    setText(document.querySelector('#shopify-pc__prefs__header-decline'), copy.decline);
    setText(document.querySelector('#shopify-pc__prefs__header-save'), copy.save);
    setText(
      document.querySelector(`${prefsDialogSelector} .shopify-pc__prefs__intro h3`),
      copy.introTitle
    );
    setText(
      document.querySelector(`${prefsDialogSelector} .shopify-pc__prefs__intro p`),
      copy.introBody
    );

    setOptionCopy('#shopify-pc__prefs__essential', copy.essentialTitle, copy.essentialBody);
    setOptionCopy(
      '#shopify-pc__prefs__personalization',
      copy.personalizationTitle,
      copy.personalizationBody
    );
    setOptionCopy(
      '#shopify-pc__prefs__preferences',
      copy.personalizationTitle,
      copy.personalizationBody
    );
    setOptionCopy('#shopify-pc__prefs__marketing', copy.marketingTitle, copy.marketingBody);
    setOptionCopy('#shopify-pc__prefs__analytics', copy.analyticsTitle, copy.analyticsBody);
    setAlwaysEnabledCopy();
    localizeJapaneseFallbackCopy();
    styleEssentialCheckbox();
  };

  const applyCopy = () => {
    if (!isJapaneseStorefront) {
      setText(
        queryFirst([
          '#shopify-pc__banner__body-title',
          '#shopify-pc__banner h1',
          '#shopify-pc__banner h2',
          '#shopify-pc__banner h3',
        ]),
        copy.bannerTitle
      );
      setBannerMessage();
      setText(document.querySelector('#shopify-pc__banner__btn-manage-prefs'), copy.manage);
      setText(
        queryFirst([
          '#shopify-pc__banner__btn-accept',
          '#shopify-pc__banner__btn-accept-all',
        ]),
        copy.accept
      );
      setText(
        queryFirst([
          '#shopify-pc__banner__btn-decline',
          '#shopify-pc__banner__btn-decline-all',
        ]),
        copy.decline
      );
    }

    applyPreferencesCopy();
  };

  const observePreferences = () => {
    const preferences = document.querySelector(prefsSelector);
    if (preferences === observedPreferences) return;

    preferencesObserver?.disconnect();
    observedPreferences = preferences;
    if (!preferences) return;

    preferencesObserver = new MutationObserver(scheduleUpdate);
    preferencesObserver.observe(preferences, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
    });
  };

  function scheduleUpdate() {
    if (updateQueued) return;
    updateQueued = true;

    requestAnimationFrame(() => {
      updateQueued = false;
      observePreferences();
      applyCopy();
      ensureCloseControl();
      syncOpenState();
    });
  }

  const getPrivacyBannerApi = () =>
    window.privacyBanner ||
    (typeof privacyBanner !== 'undefined' ? privacyBanner : null);

  const loadPrivacyBannerApi = () => {
    const api = getPrivacyBannerApi();
    if (api?.showPreferences) return Promise.resolve(api);
    if (privacyBannerLoader) return privacyBannerLoader;

    privacyBannerLoader = new Promise((resolve, reject) => {
      const src =
        'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
      let script = document.querySelector(`script[src="${src}"]`);

      const finish = () => {
        const loadedApi = getPrivacyBannerApi();
        if (loadedApi?.showPreferences) resolve(loadedApi);
        else reject(new Error('Shopify privacy banner API unavailable'));
      };

      if (!script) {
        script = document.createElement('script');
        script.src = src;
        script.async = true;
        document.head.appendChild(script);
      }

      script.addEventListener('load', finish, { once: true });
      script.addEventListener('error', reject, { once: true });
      window.setTimeout(finish, 0);
    }).catch((error) => {
      privacyBannerLoader = null;
      throw error;
    });

    return privacyBannerLoader;
  };

  const openPreferences = () => {
    const nativeManage = document.querySelector(
      '#shopify-pc__banner__btn-manage-prefs'
    );

    if (nativeManage) {
      nativeManage.click();
      nativeManage.blur?.();
      clearCookiePointerFocusAfterOpen();
      window.setTimeout(scheduleUpdate, 0);
      return;
    }

    loadPrivacyBannerApi()
      .then((api) => api.showPreferences())
      .then(() => {
        clearCookiePointerFocusAfterOpen();
        scheduleUpdate();
      })
      .catch(() => {});
  };

  document.addEventListener(
    'mousedown',
    (event) => {
      const nativeManage = event.target.closest?.(
        '#shopify-pc__banner__btn-manage-prefs'
      );
      if (!nativeManage) return;

      event.preventDefault();
      clearSelection();
      nativeManage.blur?.();
    },
    true
  );

  document.addEventListener(
    'selectstart',
    (event) => {
      if (
        event.target.closest?.('#shopify-pc__banner__btn-manage-prefs')
      ) {
        event.preventDefault();
      }
    },
    true
  );

  document.addEventListener('click', (event) => {
    const nativeManage = event.target.closest?.(
      '#shopify-pc__banner__btn-manage-prefs'
    );

    if (nativeManage && event.detail > 0) {
      clearSelection();
      nativeManage.blur?.();
      clearCookiePointerFocusAfterOpen();
    }

    const customClose = event.target.closest?.(`.${customCloseClass}`);
    if (customClose) {
      event.preventDefault();
      event.stopPropagation();
      closePreferences();
      return;
    }

    const settingsButton = event.target.closest?.('[data-cookie-settings]');
    if (!settingsButton) return;

    event.preventDefault();
    settingsButton.blur?.();
    openPreferences();
  });

  const documentObserver = new MutationObserver(scheduleUpdate);
  documentObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.addEventListener(
    'scroll',
    () => {
      if (
        document.body.classList.contains('hy-cookie-prefs-open') &&
        Math.abs(window.scrollY - lockedScrollY) > 1
      ) {
        window.scrollTo(0, lockedScrollY);
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'wheel',
    (event) => {
      if (!document.body.classList.contains('hy-cookie-prefs-open')) return;
      if (!event.target.closest?.(prefsScrollableSelector)) event.preventDefault();
    },
    { capture: true, passive: false }
  );

  document.addEventListener(
    'touchmove',
    (event) => {
      if (!document.body.classList.contains('hy-cookie-prefs-open')) return;
      if (!event.target.closest?.(prefsDialogSelector)) event.preventDefault();
    },
    { capture: true, passive: false }
  );

  scheduleUpdate();
})();